import { userStore } from "../../stores/user.store";
import { configStore } from "../../stores/config.store";
import set from "set-value";
import get from "get-value";

let configStoreValue;

configStore.subscribe((value) => {
  configStoreValue = value;
});

/**
 * z mapy si zistim zemepisnu dlzku, sirku a zoom
 * a tieto informacie nasledne ulozim do storage
 * @param {object} map
 */
export function ulozAktualneZobrazenieMapy(map) {
  const { lat, lng, zoom } = ziskajAktualnuPoziciuMapy(map);

  const u = userStore.getUser();
  set(u, "options.mapa.lat", lat);
  set(u, "options.mapa.lng", lng);
  set(u, "options.mapa.zoom", zoom);

  userStore.updateUser(u);
}

/**
 * Ziskam aktualnu poziciu mapy. Cize vzdy ked sa na mape posuniem alebo
 * upravim zoom, tak sa mi zisti aktualna pozicia a zoom
 * @param {object} map
 */
function ziskajAktualnuPoziciuMapy(map) {
  const center = map.getCenter();
  const zoom = Math.round(map.getZoom() * 100) / 100;
  // derived from equation: 512px * 2^z / 360 / 10^d < 0.5px
  const precision = Math.ceil(
    (zoom * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10
  );
  const m = Math.pow(10, precision);
  const lng = Math.round(center.lng * m) / m;
  const lat = Math.round(center.lat * m) / m;

  return { lat, lng, zoom };
}

/**
 * Potrebujem ziskat ulozenu poziciu mapy.
 * Bud ju mam ulozenu v storage (ak uz som bol prihlasny)
 * alebo natiahnem udaje z configu
 */
export function ziskajUlozenuPoziciuMapy() {
  const u = userStore.getUser();
  let lat =
    get(u, "options.mapa.lat", false) ||
    get(configStoreValue, "pociatocne_pozicie.lat");
  let lng =
    get(u, "options.mapa.lng", false) ||
    get(configStoreValue, "pociatocne_pozicie.lng");
  let zoom =
    get(u, "options.mapa.zoom", false) ||
    get(configStoreValue, "pociatocne_pozicie.zoom");

  if (lat && lng && zoom) {
    return { lat, lng, zoom };
  }
}
